/* eslint-disable import/prefer-default-export */
import InsignFrontCookie from './InsignFrontCookie.class.js'

export {
  InsignFrontCookie,
}
